import * as Accordion from "@radix-ui/react-accordion";
import { Plus } from "lucide-react";
import { Reveal, Overline } from "./Reveal";

const FAQS = [
  {
    q: "What can I expect during a consultation?",
    a: "A calm, unhurried one-on-one conversation about your health, daily rhythms, and what you hope to change. You'll leave with clear, personal next steps, never a lecture.",
  },
  {
    q: "What is iridology?",
    a: "Iridology is the study of patterns in the iris, used as an educational tool to explore constitutional tendencies. It's included in the Full 90-Minute Consultation.",
  },
  {
    q: "Are sessions held online?",
    a: "Yes. Consultations meet online, so you can join from the quiet of your own home. No travel, no childcare logistics to solve.",
  },
  {
    q: "How do I prepare for my session?",
    a: "After booking, you'll receive a short questionnaire to complete beforehand. That's all. Bring yourself, your questions, and an honest picture of where you are.",
  },
];

export const FAQ = () => (
  <section id="faq" data-testid="faq-section" className="py-24 sm:py-32">
    <div className="mx-auto max-w-3xl px-5 sm:px-8">
      <Reveal className="text-center">
        <Overline>Questions</Overline>
        <h2 className="font-serif text-3xl leading-tight text-forest sm:text-4xl lg:text-5xl">
          Frequently Asked Questions
        </h2>
        <p className="mt-5 text-sm text-taupe">
          Preliminary answers. Staci's final FAQs are on their way.
        </p>
      </Reveal>
      <Reveal delay={0.12}>
        <Accordion.Root type="single" collapsible className="mt-12">
          {FAQS.map((f, i) => (
            <Accordion.Item
              key={i}
              value={`faq-${i}`}
              data-testid={`faq-item-${i}`}
              className="border-b border-forest/12"
            >
              <Accordion.Header>
                <Accordion.Trigger
                  data-testid={`faq-trigger-${i}`}
                  className="group flex w-full items-center justify-between gap-6 py-6 text-left"
                >
                  <span className="font-serif text-lg text-forest transition-colors duration-300 group-hover:text-gold-dark sm:text-xl">
                    {f.q}
                  </span>
                  <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-forest/15 transition-all duration-300 group-data-[state=open]:rotate-45 group-data-[state=open]:border-gold group-data-[state=open]:bg-gold/10">
                    <Plus className="h-4 w-4 text-forest" />
                  </span>
                </Accordion.Trigger>
              </Accordion.Header>
              <Accordion.Content
                data-testid={`faq-content-${i}`}
                className="overflow-hidden data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down"
              >
                <p className="pb-7 pr-14 leading-relaxed text-charcoal/70">{f.a}</p>
              </Accordion.Content>
            </Accordion.Item>
          ))}
        </Accordion.Root>
      </Reveal>
    </div>
  </section>
);
